import { Layout } from 'antd';
import Styles from '../assets/layoutStyles.scss';
import { ISiderProps } from '../entities';

const BCSider = (props: ISiderProps) => (
	<Layout.Sider
		{...props}
		className={[props.className, Styles.sider].join(' ')}
	/>
);

export default BCSider;
